module.exports = __webpack_public_path__ + "img/PositionCamionStart.4f2d1a60.svg";